import React, { useState } from 'react';

import TabNavigator from '../tabNavigator';
import AcquisitionsAssumptions from './tabs/acquisitionsAssumptionsTab';
import AcquisitionsSalesTargets from './tabs/acquisitionsSalesTargetsTab';
import AcquisitionsMonthlyDashboard from './tabs/acquisitionsMonthlyDashboardTab';
import AcquisitionsOverview from './tabs/acquisitionsOverviewTab';
import AcquisitionsSalesDates from './tabs/acquisitionsSalesDatesTab';

export const AcquisitionsTabNames = {
    Overview: 'Overview',
    MonthlyDashboard: 'Monthly Dashboard',
    SalesTargets: 'Sales Targets',
    Assumptions: 'Assumptions',
    SalesDates: 'Sales Dates',
};

function AcquisitionsTabs({ acquisitionsData }) {
    const { assumptions, targets, tableData, salesActualDates } =
    acquisitionsData;
    const [selectedTab, setSelectedTab] = useState(AcquisitionsTabNames.Overview);

    const selectTab = (tab) => setSelectedTab(tab);

    const tabs = AcquisitionsTabNames;

    const getTabContentsComponent = () => {
        switch (selectedTab) {
        case AcquisitionsTabNames.MonthlyDashboard:
            return (
                <AcquisitionsMonthlyDashboard
                    assumptions={assumptions}
                    overview={tableData}
                />
            );
        case AcquisitionsTabNames.Overview:
            return (
                <AcquisitionsOverview
                    assumptions={assumptions}
                    overview={tableData}
                />
            );
        case AcquisitionsTabNames.SalesTargets:
            return (
                <AcquisitionsSalesTargets
                    assumptions={assumptions}
                    targets={targets}
                />
            );
        case AcquisitionsTabNames.Assumptions:
            return <AcquisitionsAssumptions assumptions={assumptions} />;
        case AcquisitionsTabNames.SalesDates:
            return <AcquisitionsSalesDates salesDates={salesActualDates} />;
        default:
            return null;
        }
    };

    return (
        <>
            <div className="col-12">
                <TabNavigator selected={selectedTab} onSelect={selectTab} tabs={tabs} />
            </div>
            <div className="mt-4">{getTabContentsComponent()}</div>
        </>
    );
}

export default AcquisitionsTabs;
